module.exports = __webpack_public_path__ + "static/restaurant-server-checklist-08d6e1b4abf79eee44ad6379f3af36e8.jpg";